import { useTranslation } from '@lyearn/i18n';
import FilterBody from '@/components/FilterNew/components/Body';

import { FilterBodyRendererProps } from '../types';

export const FilterBodyRenderer = ({
  selectedPathConfig,
  onBack,
  onChange,
}: FilterBodyRendererProps) => {
  const {
    id,
    listConfig,
    initialSelectedOptions,
    uiConfig,
    headerProps,
    initialSelectedOperator,
    CustomRenderer,
    queryParams,
  } = selectedPathConfig;
  useTranslation('Tags');

  const Component = CustomRenderer ?? FilterBody;

  return (
    <Component
      headerProps={{
        ...headerProps,
        onBack,
      }}
      initialSelectedOperator={initialSelectedOperator}
      initialSelectedOptions={initialSelectedOptions}
      listConfig={listConfig}
      queryParams={queryParams}
      uiConfig={uiConfig}
      onChange={(value, selectedOperator) => {
        onChange(id, value, selectedOperator);
      }}
    />
  );
};
